import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function ReframeSection() {
  return <section className="py-12 md:py-32 px-4 bg-secondary-bg relative overflow-hidden" data-id="element-318">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-319">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-12" data-id="element-320">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4 md:mb-8 leading-tight" data-id="element-321">
            No es mala suerte. No estás roto/a. Te falta un sistema.
          </h2>
        </motion.div>

        <div className="space-y-4 md:space-y-6 text-base md:text-xl lg:text-2xl font-body-serif text-text-primary leading-relaxed text-center md:text-left" data-id="element-322">
          <p data-id="element-323">
            Lo que sentís tiene nombre:{' '}
            <span className="text-gold font-bold" data-id="element-324">desorden acumulado</span>. No
            hablamos solo del desorden físico — hablamos de decisiones sin
            estructura, hábitos que drenan energía, ambientes que no protegés y
            fugas que no ves.
          </p>
          <p data-id="element-325">
            Cuando no hay un sistema, todo se siente pesado. Pero cuando ponés
            orden visible, algo cambia: pensás mejor, decidís mejor, dormís
            mejor. No es magia. Es causa y efecto.
          </p>
          <p className="text-text-secondary italic" data-id="element-326">
            El Código de Restauración 24/7 te da ese sistema. Paso a paso. Sin
            culpa. Sin presión. A tu ritmo, pero con guía.
          </p>
        </div>

        <div className="mt-8 md:mt-16 p-4 md:p-8 rounded-xl md:rounded-2xl bg-card-bg border border-border-gold shadow-md" data-id="element-327">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-2" data-id="element-328">
            {[{
            label: 'Paso 1',
            value: 'Orden visible',
            highlight: false
          }, {
            label: 'Paso 2',
            value: 'Claridad mental',
            highlight: false
          }, {
            label: 'Paso 3',
            value: 'Mejores decisiones',
            highlight: false
          }, {
            label: 'Resultado',
            value: 'Resultados concretos',
            highlight: true
          }].map((step, idx) => <Fragment key={idx} data-id="element-329">
                {idx > 0 && <ArrowRightIcon className="text-gold w-5 h-5 rotate-90 md:rotate-0 shrink-0" data-id="element-330" />}
                <div className="text-center" data-id="element-331">
                  <span className="block text-gold font-bold text-sm md:text-lg mb-0.5" data-id="element-332">
                    {step.label}
                  </span>
                  <span className={`text-sm md:text-base font-medium ${step.highlight ? 'text-gold-bright font-bold' : 'text-text-primary'}`} data-id="element-333">
                    {step.value}
                  </span>
                </div>
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}